import { Switch, withStyles } from "@material-ui/core";

const AntSwitch = withStyles((theme) => ({
    root: {
      width: 32,
      height: 16,
      padding: 0,
      display: 'flex',
      overflow: 'visible',
      borderRadius: 8
    },
    switchBase: {
      padding: 2,
      color: '#ffffff',
      '&$checked': {
        transform: 'translateX(12px)',
        color: '#ffffff',
        '& + $track': {
          opacity: 1,
          backgroundColor: '#1891F6',
          borderColor: '#1891F6',
        },
      },
    },
    thumb: {
      width: 14,
      height: 14,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid #ffffff`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: '#BAC0D0',
    },
    checked: {},
  }))(Switch);

  export default AntSwitch;